import { CookieUtils, } from '@haaretz/vanilla-user-utils';
import getUser from './getUser';
import { SITE, } from '../../consts';

import requiredArg from './requiredArg';
import withTimeout from '../withTimeout';

export const DS_BASE_URL = `https://services.${SITE}/ds`;

export async function getStatBaseData() {
  // Build a user from a newly parsed (hence :'true' param) cookie state
  const user = getUser();

  const type = user.type === 'anonymous' ? 'Anonymous' : user.extendedUserType;

  const hasUserDetails = !!CookieUtils.getCookie('user_details');
  const hasSso = !!CookieUtils.getCookie('sso_token');

  if (hasUserDetails && hasSso && user.anonymousId) {
    return {
      page_type: 'article',
      url: document.URL || '',
      domain: window.location.hostname || '',
      Rusr:
        CookieUtils.getCookie('user_details')?.userType === 'registered'
        || null,
      Pusr:
        CookieUtils.getCookie('user_details')?.userType === 'paying' || null,
      aun: CookieUtils.getCookie('aun') || '',
      userId: user.id || '',
      anonymousId: user.anonymousId || '',
      react: false,
      useragent: window.encodeURIComponent(window.navigator.userAgent),
      article_type: 'interactiveArticle',
      ...parseDataAttrs(document.documentElement),
      ...parseUtms(),
      platfrom: window.innerWidth < 500 ? 'Moblie' : 'Desktop',
      width: window.innerWidth,
      ad_block_state: window.localStorage.hasAdBlock || 'false',
      user_type: type,
      referrer_type: window.document.referrer,
    };
  }
  return {
    page_type: 'connections',
    url: document.URL || '',
    domain: window.location.hostname || '',
    react: false,
    useragent: window.encodeURIComponent(window.navigator.userAgent),
    article_type: 'interactiveArticle',
    ...parseDataAttrs(document.documentElement),
    ...parseUtms(),
    platfrom: window.innerWidth < 500 ? 'Moblie' : 'Desktop',
    width: window.innerWidth,
    ad_block_state: window.localStorage.hasAdBlock || 'false',
    referrer_type: window.document.referrer,
    user_type: type,
    // anonymous_id: user.anonymousId || '',
  };
}

export async function sendBiEvent({
  eventType = requiredArg('eventType'),
  data = requiredArg('data'),
}) {
  const validBiEventTypes = [ 'action', 'impression', ];
  if (!validBiEventTypes.includes(eventType)) {
    throw new Error(
      `"${eventType}" isn't a valid "eventType" for sendBiEvent.\n`
        + `Valid "eventType"s are: ${validBiEventTypes
          .map(evtType => `"${evtType}"`)
          .join(' | ')}`
    );
  }

  if (window.location.hostname === 'localhost') {
    // TODO: REMOVE THIS
    return;
  }

  const baseData = await getStatBaseData();
  const serialiezedData = JSON.stringify({ ...baseData, ...data, });

  if (eventType === 'action' && typeof navigator.sendBeacon === 'function') {
    navigator.sendBeacon(`${DS_BASE_URL}/actionPlain`, serialiezedData);
  }
  else {
    try {
      withTimeout(
        window.fetch(`${DS_BASE_URL}/${eventType}`, {
          method: 'POST',
          headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
          body: serialiezedData,
          cache: 'no-cache',
          credentials: 'include',
        })
      );
    }
    catch (err) {
      // eslint-disable-next-line no-console
      console.error(err.stack);
    }
  }
}

// ////////////////////////////////////////////////////////////////// //
//                              HELPERS                               //
// ////////////////////////////////////////////////////////////////// //

function parseUtms() {
  const paramsWhitelist = [
    'medium',
    'content',
    'source',
    'campaign',
    'type',
  ].reduce((params, param) => [ ...params, `utm_${param}`, `htm_${param}`, ], []);

  return (
    window.location.search
      .slice(1)
      .split('&')
      .reduce((params, item) => {
        const [ param, value, ] = item.split('=');

        // empty params are meaningless
        if (!value) return params;

        const [ prefix, ...rest ] = param.split('_');
        const suffix = rest
          .map(word => {
            const [ , firstChar, end, ] = word.match(/(.)(.*)/);
            return firstChar.toUpperCase() + end;
          })
          .join('');
        const utmParam = [ 'utm', suffix, ].join('');

        // Prefer 'htm' params over 'utm' params
        if (params[utmParam] && prefix === 'utm') return params;

        // Filter out irrelevant params
        if (paramsWhitelist.includes(param)) return { ...params, [utmParam]: value, };

        return params;
      }, {}) || {}
  );
}

export function parseDataAttrs(element = document.documentElement) {
  const dataAttrsWhitelist = {
    article_id: noop,
    blocked: value => value === 'true',
    primary_section: noop,
    secondary_section: noop,
    writer_id: noop,
    writer_name: noop,
  };

  return Object.entries(element.dataset).reduce((result, entry) => {
    const [ attr, val, ] = entry;
    return Object.keys(dataAttrsWhitelist).includes(attr)
      ? {
        ...result,
        [attr]: dataAttrsWhitelist[attr](val),
      }
      : result;
  }, {});
}

function noop(value) {
  return value;
}
